import { IconButton, styled } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

type PropsType = { onClick: () => void; isActive: boolean };

/**
 * Appears at sm breakpoint width (less than 724px)
 */
export const BurgerButton = ({ onClick, isActive }: PropsType) => {
  const BurgerIcon = styled(IconButton)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 4,
    [theme.breakpoints.down(924)]: {
      display: 'flex',
    },
    [theme.breakpoints.up(924)]: {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    backgroundColor: isActive ? theme.palette.grey[100] : 'transparent',
  }));

  return (
    <BurgerIcon onClick={onClick}>
      <MenuIcon fontSize='medium' />
    </BurgerIcon>
  );
};
